import { flsModules } from "./modules.js";

document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('[data-language-dropdown]');

  if (!dropdowns.length) return;

  dropdowns.forEach((dropdown) => {
    const toggle = dropdown.querySelector('.language-dropdown__toggle');
    const menu = dropdown.querySelector('.language-dropdown__menu');

    if (!toggle || !menu) return;

    const closeDropdown = () => {
      dropdown.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    };

    const openDropdown = () => {
      dropdown.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      menu.hidden = false;
    };

    const toggleDropdown = () => {
      const isOpen = dropdown.classList.contains('is-open');

      document.querySelectorAll('[data-language-dropdown].is-open').forEach((item) => {
        const itemToggle = item.querySelector('.language-dropdown__toggle');
        const itemMenu = item.querySelector('.language-dropdown__menu');

        item.classList.remove('is-open');

        if (itemToggle) {
          itemToggle.setAttribute('aria-expanded', 'false');
        }

        if (itemMenu) {
          itemMenu.hidden = true;
        }
      });

      if (!isOpen) {
        openDropdown();
      }
    };

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      toggleDropdown();
    });

    document.addEventListener('click', (event) => {
      if (!dropdown.contains(event.target)) {
        closeDropdown();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDropdown();
        toggle.blur();
      }
    });
  });
});

console.log("Language");
